$(document).ready(function () {

  // testimonial section
  if($('.testimonials-sec').length > 0 && $('.testimonial-txt-slider').length > 0){
    const testimoniol_profileSwiper = new Swiper('.testimonial-profile-slider', {
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      allowTouchMove: false,
    });

    const testimoniol_textSwiper = new Swiper('.testimonial-txt-slider', {
      slidesPerView: 1,
      autoHeight: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      thumbs: {
        swiper: testimoniol_profileSwiper,
      }
    });
  }
  // testimonial section

  // Main Bnnaer Video Btn
  // if($('[data-main-banner-video-play]').length > 0){
  //   $('[data-main-banner-video-play]').on('click',function (e) {
  //     e.preventDefault();
  //     if($(this).parents('.media-block').hasClass('active')){
  //       $(this).next('video')[0].pause();
  //       $(this).parents('.media-block').removeClass('active');
  //     }else{
  //       $(this).next('video')[0].play();
  //       $(this).parents('.media-block').addClass('active');
  //     }
  //   });
  // }
  // Main Bnnaer Video Btn


  // Product Main Media Gallary
  if($('.product__main-media-wrap').length > 0){
    $('.product__main-media-wrap').each(function () {
      var $section = $(this);

      var thumbEl = $section.find('.product__main-media-thumb')[0];
      var mainEl  = $section.find('.product__main-media-list')[0];

      if (!thumbEl || !mainEl) return;

      var product_media_thumb = new Swiper(thumbEl, {
        slidesPerView: 'auto',
        spaceBetween: 11,
        mousewheel: {
          forceToAxis: true
        },
        direction: 'vertical',
        breakpoints: {
          990: {
            spaceBetween: 5,
          },
        },
        watchSlidesProgress: true,
      });

      var product_main_media = new Swiper(mainEl, {
        slidesPerView: 1,
        spaceBetween: 15,
        // autoHeight: true,
        thumbs: {
          swiper: product_media_thumb,
        },
      });
    });
  }
  // Product Main Media Gallary

  // Product Accordion
  if($('.product_collaps_tab').length > 0){
    $('.product_collaps_tab .product_collaps_tab-toggle').click(function () {
      $(this).parent('.product_collaps_tab').toggleClass('active');
      $(this).next('.product_collaps_tab_content').slideToggle();
    })
  }
  // Product Accordion

  // Product Key Ingredient accordion
  if($('.product_key_ingredients-row').length > 0 && $(window).width() > 750){
    const product_key_ingredients = new Swiper('.product_key_ingredients-row', {
      slidesPerView: 'auto',
      spaceBetween: 14
    });
  }
  // Product Key Ingredient accordion


  //  FAQ
  if($('[data-faq-block]').length > 0){
    $('[data-faq-block] [data-faq-toggle]').click(function (e) {
      e.preventDefault();
      $(this).next('[data-faq-content]').slideToggle().parents('[data-faq-block]').toggleClass('active');
    });
  }
  //  FAQ


  

  // Featured Collection Slider
  if($('.featured-collection-slider').length > 0){
    const featured_collection_slider = new Swiper('.featured-collection-slider-row',{
      slidesPerView: 'auto',
      spaceBetween: 18,
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: ".featured-collection-slider-row .swiper-button-next",
        prevEl: ".featured-collection-slider-row .swiper-button-prev",
      },
      mousewheel: {
        forceToAxis: true
      },
      breakpoints: {
        990: {
          spaceBetween: 28,
        },
      },
    });
  }
  // Featured Collection Slider


  // Newsletter Popup
  if($('#newsletter-popup').length > 0){
    if (window.location.href.indexOf('customer_posted=true#newsletter-modal') > -1) {
        $('#newsletter-popup').addClass('open-newsletter');
    }
    setTimeout(function(){
      if (!$.cookie('disabled_newsletter_popup')) {
        $('#newsletter-popup').addClass('open-newsletter');
      }
    }, 5000);
    $('#newsletter-popup-close').click(function(e) {
      e.preventDefault();
      $('#newsletter-popup').removeClass('open-newsletter');
      $.cookie('disabled_newsletter_popup', 'true', { expires: 2 });
    });
  }
  // Newsletter Popup


  // Product page Collapsible tab See more
  if ($('.product-main-section .product__accordion.default-open').length > 0) {
    $('.product-main-section .product__accordion.default-open').each(function () {
      const rteElement = $(this).find('.content--wrap')[0];
      if (rteElement && rteElement.scrollHeight > rteElement.clientHeight) {
        $(this).find('.see-more-desc').show();
      }
    });

    $('.product__accordion .see-more-desc').on('click', function () {
      $(this).closest('.product_collaps_tab_content').toggleClass('expanded');
    });
  }
  // Product page Collapsible tab See more


  // Nutrition Popup
  if($('#nutrition-popup').length > 0){
    $(document).on('click','[data-nutrition-popup]',function(e){
      e.preventDefault();
      $('[data-nutrition-popup-content]').html($(this).next('.product-nutrition-info').html());
      setTimeout(function(){$('#nutrition-popup').fadeIn()}, 100);
    });

    $(document).on('click','#nutrition-popup-close',function(e){
      e.preventDefault();
      $('#nutrition-popup').fadeOut();
      setTimeout(function(){$('[data-nutrition-popup-content]').empty()}, 300);
    });
  }
  // Nutrition Popup
  
});



